import candidate from "@/redux/slices/commonSlices/candidateSlice";
import request from "@/redux/slices/commonSlices/requestSlice";
import settings from "@/redux/slices/commonSlices/settingsSlice";
import upload from "@/redux/slices/commonSlices/uploadSlice";
import viewTabs from "@/redux/slices/commonSlices/viewTabsSlice";
import chat from "@/redux/slices/mlSlices/chatSlice";
import summarization from "@/redux/slices/mlSlices/summarizationSlice";
import createProduct from "@/redux/slices/productSlices/createSlice";
import editProduct from "@/redux/slices/productSlices/editSlice";
import productOptions from "@/redux/slices/productSlices/optionsSlice";
import tableProduct from "@/redux/slices/productSlices/tableSlice";
import viewProduct from "@/redux/slices/productSlices/viewSlice";
import createScenario from "@/redux/slices/scenarioSlices/createSlice";
import editScenario from "@/redux/slices/scenarioSlices/editSlice";
import scenarioOptions from "@/redux/slices/scenarioSlices/optionsSlice";
import tableScenario from "@/redux/slices/scenarioSlices/tableSlice";
import viewScenario from "@/redux/slices/scenarioSlices/viewSlice";
import tableSession from "@/redux/slices/sessionSlices/tableSlice";
import viewSession from "@/redux/slices/sessionSlices/viewSlice";
import createUser from "@/redux/slices/userSlices/createSlice";
import editUser from "@/redux/slices/userSlices/editSlice";
import userOptions from "@/redux/slices/userSlices/optionsSlice";
import tableUser from "@/redux/slices/userSlices/tableSlice";
import viewUser from "@/redux/slices/userSlices/viewSlice";
import createVideo from "@/redux/slices/videoSlices/createSlice";
import editVideo from "@/redux/slices/videoSlices/editSlice";
import tableVideo from "@/redux/slices/videoSlices/tableSlice";
import viewVideo from "@/redux/slices/videoSlices/viewSlice";

import dashboardCall from "@redux/slices/dashboardSlices/dashboardCallSlice";
import dashboardCertification from "@redux/slices/dashboardSlices/dashboardCertificationSlice";
import createCriteria from "@redux/slices/criteriaSlices/createSlice";
import editCriteria from "@redux/slices/criteriaSlices/editSlice";
import tableCriteria from "@redux/slices/criteriaSlices/tableSlice";
import viewCriteria from "@redux/slices/criteriaSlices/viewSlice";
import createDoctor from "@redux/slices/doctorSlices/createSlice";
import tableDoctor from "@redux/slices/doctorSlices/tableSlice";
import viewDoctor from "@redux/slices/doctorSlices/viewSlice";
import {combineReducers, configureStore} from "@reduxjs/toolkit";

const commonReducer = combineReducers({
  candidate,
  settings,
  viewTabs,
  upload,
  request,
});

const dashboardReducer = combineReducers({
  call: dashboardCall,
  certification: dashboardCertification,
});

const userReducer = combineReducers({
  table: tableUser,
  view: viewUser,
  create: createUser,
  edit: editUser,
  options: userOptions,
});

const scenarioReducer = combineReducers({
  table: tableScenario,
  view: viewScenario,
  create: createScenario,
  edit: editScenario,
  options: scenarioOptions,
});

const productReducer = combineReducers({
  table: tableProduct,
  view: viewProduct,
  create: createProduct,
  edit: editProduct,
  options: productOptions,
});

const doctorReducer = combineReducers({
  table: tableDoctor,
  view: viewDoctor,
  create: createDoctor,
});

const criteriaReducer = combineReducers({
  table: tableCriteria,
  view: viewCriteria,
  create: createCriteria,
  edit: editCriteria,
});

const videoReducer = combineReducers({
  table: tableVideo,
  view: viewVideo,
  create: createVideo,
  edit: editVideo,
});

const sessionReducer = combineReducers({
  table: tableSession,
  view: viewSession,
});

const mlReducer = combineReducers({
  chat,
  summarization,
});

export const store = configureStore({
  reducer: {
    common: commonReducer,
    dashboard: dashboardReducer,
    user: userReducer,
    scenario: scenarioReducer,
    doctor: doctorReducer,
    criteria: criteriaReducer,
    product: productReducer,
    video: videoReducer,
    session: sessionReducer,
    ml: mlReducer,
  },
});
